import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import "../styles/Navbar.css";
import stonesAnimation from "../assets/animations/stones.json";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [logoHover, setLogoHover] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("resetToFrame1"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (isMobile) {
    return (
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          <Link className="navbar-logo-mobile" onClick={scrollToTop} to="/">
            <span>stone</span>
          </Link>
        </div>
      </nav>
    );
  }

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <Link
          className="navbar-logo"
          to="/"
          onClick={scrollToTop}
          onMouseEnter={() => setLogoHover(true)}
          onMouseLeave={() => setLogoHover(false)}
          style={{ position: "relative", display: "inline-block" }}
        >
          <span style={{ visibility: logoHover ? "hidden" : "visible" }}>
            stone
          </span>
          {logoHover && (
            <div
              style={{
                position: "absolute",
                top: "28%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "42px",
                height: "16.8px",
                pointerEvents: "none",
              }}
            >
              <Lottie animationData={stonesAnimation} loop autoplay />
            </div>
          )}
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
